import React from "react";
import FlightCheckerBase from "./FlightCheckerBase";

export default function FlightCheckerT2() {
  return (
    <FlightCheckerBase
      terminal="2"
      defaultFlight="UA934"
      title="Heathrow Terminal 2 Flight Checker | Live T2 Flight Status, Queues, Gate & Reliability"
      metaDescription="Check Heathrow Terminal 2 flights by number with live T2 flight status, arrivals/departures, gate, check-in zone, immigration or security queue times and recent reliability context."
      metaKeywords="Heathrow Terminal 2 flight checker, Heathrow T2 flight status, Heathrow Terminal 2 arrivals, Heathrow Terminal 2 departures, Heathrow T2 gate, Heathrow T2 check-in zone, T2 immigration wait time, T2 security wait, Heathrow T2 reliability"
      canonical="https://www.cheapcabgrab.com/terminal-2-flight-checker"
      ogTitle="Heathrow Terminal 2 Flight Checker | Live T2 Status, Queues & Gate"
      ogDescription="Check Heathrow Terminal 2 flights for live status, arrivals or departures, gate, check-in zone, queue times and flight reliability."
      schemaName="Heathrow Terminal 2 Flight Checker"
      breadcrumbName="Terminal 2 Flight Checker"
      headerTitle="Heathrow Terminal 2 Flight Checker"
      headerIntro="Check Heathrow Terminal 2 arrivals and departures with terminal-specific queue times, gate details and reliability context."
      headerNote="Choose the exact Heathrow Terminal 2 arrival or departure time. Today, recent past flights and the next few days are included."
      inputPlaceholder="e.g. UA934"
      emptyInputMessage="Please enter a Terminal 2 flight number (e.g. UA934)."
      notFoundMessage="Flight not found at Heathrow Terminal 2 for the selected time. Please choose another listed Terminal 2 flight."
      resultHeading="Heathrow Terminal 2 Flight Details"
      pickupLabel="Calculate Terminal 2 pickup window →"
      faqTitle="Terminal 2 FAQs"
      faqItems={[
        { question: "How busy is Heathrow Terminal 2 security today?", answer: "Terminal 2 is usually efficient but can get busy mid-morning and early evening." },
        { question: "Is Terminal 2 faster than Terminal 5?", answer: "Generally yes, because Terminal 2 is smaller and easier to cross." },
        { question: "Does Terminal 2 have eGates?", answer: "Yes, eGates are available for eligible passports." },
        { question: "How long does it take to exit Terminal 2 after landing?", answer: "Typically 30–60 minutes depending on passport type and baggage." },
        { question: "Where should drivers wait for Terminal 2 pickups?", answer: "Short Stay is best once the passenger confirms they are landside." },
        { question: "Does Terminal 2 have long walking distances?", answer: "Less than Terminal 5; most gates are centrally located." },
      ]}
    />
  );
}
